const URI_PREFIX = 'https://www.ringcentral.com/apps';

export const normalizeUri = (uri: string): string => {
  return uri.replace(URI_PREFIX, '');
};

const replaceSpecialCharacters = (value: string): string => {
  return (value || '').replace(/&amp;/g, '&');
};

export const normalizeSitemapProperty = (value: string): string => {
  return replaceSpecialCharacters(value);
};
